/* eslint-disable react-hooks/exhaustive-deps */
import { motion } from "framer-motion"
import { useRouter } from "next/router"
import { useEffect } from "react"
import {
  getFooterData,
  getListInvestorsGovernance,
  getPostBySlug,
  getProductServiceNavbar,
} from "lib/api"
import {
  linkGovernance,
  linkInvestor,
  linkInvestorDividendPolicy,
  linkInvestorFinancialInformationReport,
  linkInvestorSupplementaryInformationChild,
  linkProductsServices,
  linkProductsServicesCinema,
  linkProductsServicesConcession,
  linkProductsServicesDigital,
  linkProductsServicesVenue,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useGeneralStore } from "store"
import Footer from "./Footer"
import Navbar from "./Navbar"

function Layout({ children, theme, page }) {
  const { setFooterData, setNavbarData, setListGovernance, setListInvestors } =
    useGeneralStore((state) => state)
  const Router = useRouter()
  const { locale } = Router
  const changeHeight = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
  }
  const fetchGeneralData = async () => {
    const productServices = await getProductServiceNavbar()
    const footerData = await getFooterData()
    const { cinema, concessions, services } = productServices
    const menuList = [
      {
        title: translations[`cinema_${locale}`],
        slug: "cinema",
        list: cinema?.map((item) => ({
          title: item[`title_${locale}`],
          slug: `${linkProductsServicesCinema}/${item.slug}`,
        })),
      },
      {
        title: translations[`concession_${locale}`],
        slug: "concessions",
        list: concessions?.map((item) => ({
          title: item[`title_${locale}`],
          slug: `${linkProductsServicesConcession}/${item.slug}`,
        })),
      },
      {
        title: translations[`services_${locale}`],
        slug: "services",
        list: services?.map((item) => ({
          title: item[`title_${locale}`],
          slug: `${item.link_url}`,
        })),
      },
      {
        title: translations[`venues_other_income_${locale}`],
        slug: "venue",
        list: [
          {
            title: translations[`the_ballroom_${locale}`],
            slug: `${linkProductsServicesVenue}/the-ballroom`,
          },
          {
            title: translations[`other_income_${locale}`],
            slug: `${linkProductsServicesVenue}/others`,
          },
        ],
      },
      {
        title: translations[`digital_products_${locale}`],
        slug: "digital",
        list: [
          {
            title: "m.tix",
            slug: `${linkProductsServicesDigital}/m-tix`,
          },
          {
            title: "TIX.ID",
            slug: `${linkProductsServicesDigital}/tix-id`,
          },
        ],
      },
      // {
      //   title: "m.tix",
      //   slug: `${linkProductsServicesDigital}/m-tix`,
      // },
    ]
    setFooterData(footerData)
    setNavbarData(menuList)
  }
  const fetchInvestorsGovernanceMenu = async () => {
    const governance = await getListInvestorsGovernance(
      +process.env.GOVERNANCE_ID
    )
    const governanceMenu = governance?.length
      ? governance?.map((item) => ({
          ...item,
          link: `${linkGovernance}/${item.slug}`,
        }))
      : []
    const investors = await getListInvestorsGovernance(+process.env.INVESTOR_ID)
    const investorsMenu = investors?.length
      ? investors?.map((item) => {
          if (item.slug.includes("dividend")) {
            return {
              ...item,
              link: linkInvestorDividendPolicy,
              parent: "dividend",
            }
          }
          if (item.slug.includes("financial-information")) {
            return {
              ...item,
              link: linkInvestorFinancialInformationReport,
              parent: "financial-information",
            }
          }
          if (item.slug.includes("supplementary-information")) {
            return {
              ...item,
              link: linkInvestorSupplementaryInformationChild,
              parent: "supplementary-information",
            }
          }
          return {
            ...item,
            link: `${linkInvestor}/${item.slug}`,
          }
        })
      : []
    setListGovernance(governanceMenu)
    setListInvestors(investorsMenu)
  }
  useEffect(() => {
    changeHeight()
    window.addEventListener("resize", changeHeight)
    return () => window.removeEventListener("resize", changeHeight)
  }, [])
  useEffect(() => {
    fetchGeneralData()
    fetchInvestorsGovernanceMenu()
  }, [locale])
  return (
    <>
      <motion.div
        key={page}
        className={`layout-child-${page}`}
        initial={{ opacity: 0.1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0.1 }}
        transition={{ duration: 0.5 }}
      >
        <Navbar theme={theme} page={page} />
        {children}
        <Footer />
      </motion.div>
    </>
  )
}

export default Layout
